<template lang="pug">

  .wrapper
    .bars-chart-type-wrapper(v-if="loading || graphData")

      slot
        div.center-element
          span.fs-19.main {{ graphTitle }}
          span.fs-13(v-if="graphSubTitle") {{ graphSubTitle }}

      div(v-if="!loading && graphData")

        BarsChart(
          :data="graphData",
          :barsWidth="barsWidth",
          v-on="$listeners",
          :scrollable="scrollable",
          :options="barsChartConfig",
          key="barsComponent",
          ref="graphComponent"
        )

      div(v-else="", style="opacity: 0.3;")
        BarsChart(:data="loadingData", key="loadingChart", :barsWidth="barsWidth")

      .flags
        PCheckbox(label="habilitar scroll", v-model="scrollable", style="padding-right: 20px;", @input="reloadChart")
        PCheckbox(label="exibir valores zerados", v-model="showEmpty", @input="toggleIgnoreEmpty")

</template>

<script>
import BarsChart from '../charts/BarsChart'
import PieChart from '../charts/PieChart'
import { floatToHoursMinsString } from 'src/utils'
import { mapState } from 'vuex'

export default {
  props: {
    graphData: {required: true},
    loading: {type: Boolean, 'default': false},
    showLegends: {'default': false},
    graphTitle: {type: String},
    graphSubTitle: {type: String},
    barsWidth: {type: Number, default: 10}
  },
  data () {
    return {
      loadingData: {
        datasets: [
          {
            data: [1, 2, 3, 4, 5].map(i => Math.floor((Math.random() * 30) + 10)),
            field: 'a',
            backgroundColor: 'lightgray'
          }
        ],
        labels: ['Item a', 'Item b', 'Item c', 'Item D', 'Item E']
      },
      barsChartConfig: {
        tooltips: {
          titleMarginBottom: 10,
          bodyFontSize: 12,
          callbacks: {
            title: function (data) {
              if (typeof data[0].xLabel === 'string' || data[0].xLabel instanceof String) {
                return data[0].xLabel
              } else {
                return data[0].xLabel.join(' ')
              }
            },
            label: (item, data) => {
              if (this.typeView !== 'special') {
                return `${floatToHoursMinsString(data.datasets[item.datasetIndex].data[item.index])} hrs`
              } else {
                return `${data.datasets[item.datasetIndex].data[item.index]} dias`
              }
            }
          }
        }
      },
      scrollable: true,
      showEmpty: false
    }
  },
  computed: {
    ...mapState('dashboards', ['typeView'])
  },
  methods: {
    reloadChart () {
      this.$emit('loadChart')
    },
    toggleIgnoreEmpty () {
      this.$emit('toggleIgnoreEmpty', !this.showEmpty)
      this.reloadChart()
    }
  },
  components: {BarsChart, PieChart}
}
</script>

<style scoped>
.bars-chart-type-wrapper {
  width: 100%;
  height: 100%;
}
.flags {
  display: flex;
  justify-content: flex-end;
}
.title {
  display: flex;
  align-items: center;
  justify-content: center;
}
.new-window {
  display: flex;
  justify-content: flex-end;
}
.main {
  margin-right: 5px;
}
</style>
